import type { MutableRefObject } from 'react'
import { QA_WORD_COUNT_LIMIT } from '@chegg-wt/core-wa/constants/paraphraser'
import { SentenceOffset } from '@chegg-wt/core-wa/state/types'
import { EditorSelection } from '@chegg-wt/core-wa/types'
import { getWordCount } from '@chegg-wt/core-wa/utils/helpers'

export const getSynonymsSentenceOffset = (
  selection: EditorSelection,
  sentenceOffsets: SentenceOffset[],
  selectedSentenceOffSet: MutableRefObject<SentenceOffset>
) => {
  const { from, to } = selection
  for (
    let sentenceIndex = 0;
    sentenceIndex < sentenceOffsets.length;
    sentenceIndex += 1
  ) {
    const sentenceOffSet = sentenceOffsets[sentenceIndex]
    const { length, offset } = sentenceOffSet

    if (from + 1 <= offset + length) {
      if (to > offset + length) {
        // ? condition kept, as it might be needed later
        // selection between multiple sentences
      }

      // eslint-disable-next-line no-param-reassign
      selectedSentenceOffSet.current = sentenceOffSet
      break
    }
  }
}

export const shouldDisableSynonyms = (
  selection: EditorSelection,
  sentenceOffsets: SentenceOffset[],
  selectedSentenceOffSet: MutableRefObject<SentenceOffset>
) => {
  if (!selection || !selection.selectedText.trim()) return true

  // wordcount greater than QA_WORD_COUNT_LIMIT
  const wordCount = getWordCount(selection.selectedText)
  if (wordCount > QA_WORD_COUNT_LIMIT) return true

  if (sentenceOffsets.length === 0) return false
  getSynonymsSentenceOffset(selection, sentenceOffsets, selectedSentenceOffSet)
  return false
}

export const shouldDisableRewrite = (selection: EditorSelection) => {
  // if selected word count is less than the Limit
  const wordCount = selection ? getWordCount(selection.selectedText) : 0
  if (wordCount <= QA_WORD_COUNT_LIMIT) return true

  return false
}
